// LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  // Load the language from localStorage if available
  const storedLanguage = localStorage.getItem("selectedLanguage");
  const [selectedLanguage, setSelectedLanguage] = useState(storedLanguage || "EN");

  // Optionally, persist any changes to localStorage
  useEffect(() => {
    localStorage.setItem("selectedLanguage", selectedLanguage);
  }, [selectedLanguage]);

  // Clear the language from localStorage when the tab is closed
  useEffect(() => {
    const handleBeforeUnload = () => {
      localStorage.removeItem("selectedLanguage");
    };

    // For web browsers
    window.addEventListener("beforeunload", handleBeforeUnload);
    
    // For mobile devices
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") {
        localStorage.removeItem("selectedLanguage");
      }
    });
    
    // For mobile browsers that support pagehide event
    window.addEventListener("pagehide", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", () => {
        if (document.visibilityState === "hidden") {
          localStorage.removeItem("selectedLanguage");
        }
      });
      window.removeEventListener("pagehide", handleBeforeUnload);
    };
  }, []);

  return (
    <LanguageContext.Provider value={{ selectedLanguage, setSelectedLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguageContext = () => useContext(LanguageContext);
